export default "__VITE_ASSET__Bt_8Oox9__"